import React from "react";
import {Button, Card, Col, Form, Row} from "react-bootstrap";
import {actionChangeInputsPageComplaint} from "../../../../../redux/actions/pages/complaint";
import {useDispatch, useSelector} from "react-redux";
import axios from "axios";
import {BASE_URL, COMPLAINT_POST} from "../../../../../apis";
import qs from "querystring";
import swal from 'sweetalert';

const Complaint = () => {
    const dispatch = useDispatch();
    const {message} = useSelector(state => state.complaint);
    const handleSubmitForm = () => {
        if (validateForm()) {
            axios({
                url: BASE_URL + COMPLAINT_POST,
                method: 'post',
                data: qs.stringify({comment: message}),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }).then(response => {
                if (response.data.status === 'ok') {
                    swal({
                        title: "ثبت موفق",
                        buttons: {
                            cancel: "تایید",
                        },
                        icon: "success",
                    });
                } else {
                    swal({
                        title: "خطا",
                        text: "لطفا مجددا تلاش کنید.",
                        buttons: {
                            cancel: "تایید",
                        },
                        icon: "error",
                    });
                }
            }).catch(() => {
                swal({
                    title: "خطا",
                    text: "لطفا مجددا تلاش کنید.",
                    buttons: {
                        cancel: "تایید",
                    },
                    icon: "error",
                });
            });
        }
    };

    const validateForm = () => {
        if (message !== '') {
            return true;
        } else {
            swal({
                title: "خطا",
                text: "مقدار پیام نباید خالی باشد.",
                buttons: {
                    cancel: "تایید",
                },
                icon: "error",
            });
            return false;
        }
    };
    const handleInputs = (event) => {
        const {name, value} = event.target;
        dispatch(actionChangeInputsPageComplaint(name, value));
    };
    return (
        <div className={'base-box-pages-second'}>
            <Row className='justify-content-center'>
                <Col xs={12} md={6} className={'mt-1'}>
                    <Card>
                        <Card.Header className='text-center'>
                            <Card.Title className={'m-0'}>سامانه ثبت شکایات</Card.Title>
                            <small>لطفا ما را از نقایصمان آگاه کنید</small>
                        </Card.Header>
                        <Card.Body>
                            <Form onSubmit={handleSubmitForm}>
                                <Form.Group controlId="formBoxSendMessageContactUs">
                                    <Form.Label>
                                        پیام شما
                                    </Form.Label>
                                    <Form.Control as="textarea"
                                                  onChange={handleInputs}
                                                  name={'message'}
                                                  value={message}
                                                  placeholder="میتوانید پیام خود را در این کادر بنویسید" rows="4"/>
                                </Form.Group>
                            </Form>
                        </Card.Body>
                        <Card.Footer>
                            <Button variant="success" className={'base-btn-green btn-sm'} block
                                    onClick={handleSubmitForm}>ارسال</Button>
                        </Card.Footer>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default React.memo(Complaint);
